import { AfterViewInit, Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { IDriftEntryDto } from 'src/app/models/features/schema-drift/IDriftEntryDto';
import { HeaderService } from '../../../../services/_app/header/header.service';
import { SchemaDriftService } from '../../../../services/_app/schema-drift/schema-drift.service';
import { AuditProfileService } from '../../../../services/audit-profile/audit-profile.service';
import { BaseComponent } from '../../../base/base.component';
import { NgxChartsModule, Color, ScaleType } from '@swimlane/ngx-charts';

@Component({
  selector: 'app-drift-bar-chart',
  templateUrl: './drift-bar-chart.component.html',
  styleUrls: ['./drift-bar-chart.component.css']
})
export class DriftBarChartComponent extends BaseComponent implements OnInit, AfterViewInit {
  // *********************
  // variables declaration
  // *********************

  // private
  // ********

  // public
  // ******
  @Input() driftData: any;
  @Input() isDark = false;

  public chartData: any[] = [];
  public view: [number, number] = [900, 360];
  public showLegend = true;
  public xAxisLabel = 'Date';
  public yAxisLabel = 'Schema Changes';
  public legendTitle = 'Change Type';
  public colorScheme: Color = {
    name: 'schemaDrift',
    selectable: true,
    group: ScaleType.Ordinal,
    domain: ['#16a34a', '#facc15', '#dc2626']
  };

  constructor(private auditProfileService: AuditProfileService,
    private headerService: HeaderService,
    private schemaDriftService: SchemaDriftService,
    private router: Router) {
    super();
  }

  // ***************
  // lifecycle hooks
  // ***************

  override async ngOnInit() {
    await this.housekeeping();
  }

  ngAfterViewInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log('DriftTrendChartComponent - ngOnChanges', changes);
    if (changes['driftData']) {
      this.tryBuild();
    }
  }

  // *******
  // methods
  // *******

  // public
  // ******

  public getTotal(seriesGroup: any): number {
    return seriesGroup?.series?.reduce((acc: number, cur: any) => acc + cur.value, 0) || 0;
  }

  // private
  // *******

  private async housekeeping() {
    this.tryBuild();
  }

  private tryBuild(): void {
    const entries = this.driftData?.ParsedDrift;

    if (!entries || entries.length === 0) {
      this.chartData = [];

      return;
    }

    this.chartData = this.transformForChart(entries);
  }

  private transformForChart(entries: IDriftEntryDto[]): any[] {
    const map = new Map<string, { Added: number; Archived: number; Removed: number }>();
    for (const e of entries) {
      if (!map.has(e.table)) map.set(e.table, { Added: 0, Archived: 0, Removed: 0 });
      const t = map.get(e.table)!;
      if (e.action === 'Added') t.Added++;
      else if (e.action === 'Archived') t.Archived++;
      else if (e.action === 'Removed') t.Removed++;
    }

    const added = { name: 'Added', series: [] as any[] };
    const archived = { name: 'Archived', series: [] as any[] };
    const removed = { name: 'Removed', series: [] as any[] };

    Array.from(map.entries())
      .sort((a, b) => b[1].Added + b[1].Archived + b[1].Removed - (a[1].Added + a[1].Archived + a[1].Removed))
      .forEach(([table, counts]) => {
        added.series.push({ name: table, value: counts.Added });
        archived.series.push({ name: table, value: counts.Archived });
        removed.series.push({ name: table, value: counts.Removed });
      });

    return [added, archived, removed];
  }
}
